import { render, staticRenderFns } from "./ChooseContactDataPage.vue?vue&type=template&id=245f84af&scoped=true&"
import script from "./ChooseContactDataPage.vue?vue&type=script&lang=ts&"
export * from "./ChooseContactDataPage.vue?vue&type=script&lang=ts&"
import style0 from "./ChooseContactDataPage.vue?vue&type=style&index=0&id=245f84af&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "245f84af",
  null
  
)

export default component.exports